/* eslint-disable react-hooks/rules-of-hooks */

import React from 'react';

import _ from 'lodash';
import { create } from 'zustand';
import { AppInterface, AppType } from '@swivl-mono/types';
import { API } from '@swivl-mono/api-helper';
import { Member } from '../Member/Member.Current';

interface StoreInterface {
  apps?: AppInterface[];
}
const BlankState: StoreInterface = {
  apps: undefined,
};

export default class AppsModel {
  // static Store = new Store<StoreInterface>({
  //   apps: undefined,
  // });
  // static Store = {
  //   useState : create(set => ({  apps: undefined }))
  //   update:AppsModel.useState.set
  // }

  static useState = create<StoreInterface>((set) => ({ ...BlankState }));
  static setState = AppsModel.useState.setState;
  static get state() {
    return AppsModel.useState.getState();
  }
  static reset() {
    AppsModel.setState({ ...BlankState });
  }

  static useGetApp(type: AppType) {
    const { apps } = AppsModel.useState((s) => s);
    const [app, setApp] = React.useState<AppInterface | undefined>(undefined);
    React.useEffect(() => {
      if (apps) {
        setApp(apps.find((a) => a.type === type));
      }
    }, [apps, type]);
    return app;
  }

  static async load(forceRefresh) {
    if (AppsModel.state.apps && AppsModel.state.apps.length > 0 && !forceRefresh) {
      return;
    }
    const apps = await API.Apps.getApps(Member.orgId!);

    AppsModel.setState({ apps: apps.filter(app => app.active) });
  }

  static async loadApp(appType) {
    const appsByType = await API.Apps.getAppsByType(Member.orgId!, appType);
    let apps = AppsModel.state.apps ? [...AppsModel.state.apps] : [];
    for (var i = 0; i < appsByType.length; i++) {
      const existingAppIndex = apps.findIndex((a) => a.id === appsByType[i].id);
      if (existingAppIndex !== -1) {
        apps[existingAppIndex] = appsByType[i];
      } else {
        apps.push(appsByType[i]);
      }
    }
    AppsModel.setState({ apps: apps.filter(app => app.active) });
  }
  static async getAppByType(appType: AppType) {
    if (AppsModel.state.apps) {
      for (var i = 0; i < AppsModel.state.apps.length; i++) {
        if (AppsModel.state.apps[i].type === appType) {
          return AppsModel.state.apps[i];
        }
      }
    }
  }


  static async createApp(type: AppType) {
    const app = await API.Apps.createApp(Member.orgId!, type)
    let apps = AppsModel.state.apps ? [...AppsModel.state.apps] : [];
    apps.push(app);
    AppsModel.setState({ apps: apps });
    return app;
  }

  static async update(app: AppInterface, shouldSave?: boolean) {
    let apps = AppsModel.state.apps ? [...AppsModel.state.apps] : [];


    for (var i = 0; i < apps.length; i++) {
      if (apps[i].id === app.id) {
        apps[i] = app;
        AppsModel.setState({ apps: apps });

        if (shouldSave) {
          await API.Apps.updateApp(Member.orgId!, app);
        }
        break;
      }
    }
  }
  static enabledApps(): AppType[] {

    if (AppsModel.state.apps) {
      return AppsModel.state.apps.filter((a) => a.active).map((a) => a.type);
    }
    return [];
  }
  static hasApp(type) {
    if (AppsModel.state.apps) {
      for (var i = 0; i < AppsModel.state.apps.length; i++) {
        if (AppsModel.state.apps[i].type === type && AppsModel.state.apps[i].active) {
          return true;
        }
      }
    }

    return null;
  }
  // static getApp(type) {

  //   var apps = AppsModel.state.apps;
  //   if (!apps) {
  //     return null;
  //   }
  //   for (var i = 0; i < apps.length; i++) {
  //     if (apps[i].get('type') && apps[i].get('type') == type) {
  //       return apps[i];
  //     }
  //   }
  //   return null;
  // }
  static deactivateApp(app: AppInterface) {
    app.active = false;
    AppsModel.update(app, true);
  }
  //   var apps = [...AppsModel.state.apps];
  //   if (!apps) {
  //     return;
  //   }
  //   for (var i = 0; i < apps.length; i++) {
  //     if (apps[i].id === app.id) {
  //       apps.splice(i, 1);
  //       if (BotModel.state.bot && app.get('bot') && BotModel.state.bot.id == app.get('bot').id && BotModel.state.bot.get('apps')) {
  //         var bot = BotModel.state.bot;
  //         var botApps = bot.get('apps');
  //         var newBotApps = [];
  //         for (var i = 0; i < botApps.length; i++) {
  //           if (botApps[i] !== app.get('type')) {
  //             newBotApps.push(botApps[i]);
  //           }
  //         }
  //         bot.set('apps', newBotApps);
  //         bot.save();
  //         AppsModel.setState({ apps: apps });
  //       } else {
  //         AppsModel.setState({ apps: apps });
  //       }
  //       app.set('active', false);
  //       app.save();
  //       break;
  //     }
  //   }
  // }
}
